import { sendEvent } from 'model/helpers/events.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';

import { ErrorLayout } from 'features/fallback/ui/error-layout';
import { useEffect } from 'preact/hooks';

export const InvalidDevice = () => {
	const t = useLocalization();

	useEffect(() => {
		screenHistoryPush(ScreenName.invalid_device);
		setTimeout(() => {
			sendEvent({
				event: 'invalid_device_screen_shown',
			});
		}, 20);
	}, []);

	return (
		<ErrorLayout
			title={t('desktop.err.title')}
			description={t('desktop.err.subtitle')}
		/>
	);
};
